import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 5,
  class: "text-muted fs-7 w-100"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Отмена ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
    title: _ctx.title,
    width: "520px",
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = false))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        loading: _ctx.loading,
        onClick: _ctx.submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.submitText), 1)
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        onSubmit: _withModifiers(_ctx.submit, ["prevent"])
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shownFields, (field) => {
            return (_openBlock(), _createBlock(_component_el_form_item, {
              key: field.key,
              label: field.label,
              required: _ctx.isRequired(field),
              error: _ctx.errors[field.key] || ''
            }, {
              default: _withCtx(() => [
                (field.type === 'text' || field.type === 'textarea')
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: _ctx.values[field.key],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.values[field.key]) = $event),
                      type: field.type === 'textarea' ? 'textarea' : 'text',
                      rows: 3,
                      placeholder: field.placeholder
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "placeholder"]))
                  : (field.type === 'number')
                    ? (_openBlock(), _createBlock(_component_el_input_number, {
                        key: 1,
                        modelValue: _ctx.values[field.key],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.values[field.key]) = $event),
                        min: field.min,
                        max: field.max
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max"]))
                    : (field.type === 'select')
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 2,
                          modelValue: _ctx.values[field.key],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.values[field.key]) = $event),
                          multiple: field.multiple,
                          placeholder: field.placeholder,
                          clearable: "",
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: option.value,
                                label: option.label,
                                value: option.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "multiple", "placeholder"]))
                      : (field.type === 'datetime')
                        ? (_openBlock(), _createBlock(_component_el_date_picker, {
                            key: 3,
                            modelValue: _ctx.values[field.key],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.values[field.key]) = $event),
                            type: "datetime",
                            "value-format": "YYYY-MM-DD HH:mm:ss",
                            placeholder: field.placeholder,
                            class: "w-100"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                        : (field.type === 'switch')
                          ? (_openBlock(), _createBlock(_component_el_switch, {
                              key: 4,
                              modelValue: _ctx.values[field.key],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.values[field.key]) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          : _createCommentVNode("", true),
                (field.hint)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(field.hint), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["label", "required", "error"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}